import React from 'react';
import { Box, Typography } from '@mui/material';
import { DebouncedInputUI, CheckboxUI } from '../Interface';

const CalendarFilterItem = ({ hasResourceFilter, handleFilterChange, getFieldItem }) => {
  return (
    <Box>
      <DebouncedInputUI
        size="small"
        placeholder="Projekt keresés…"
        debounceMs={800}
        variant="outlined"
        setQuickFilterSearchValue={(newValue) => handleFilterChange('projectName', newValue, 'contains')}
        quickFilterSearchValue={getFieldItem('projectName')?.value}
        disabled={!hasResourceFilter}
      />
    </Box>
  );
};

export default CalendarFilterItem;
